import { utcToZonedTime } from "date-fns-tz";
import { parseISO, format, isSameDay } from "date-fns";
import { TIMEZONE } from "../../../utils/constants";
import { TimeOff } from "../types";

export const formatToLisbonTime = (dateString: string) => {
  const date = utcToZonedTime(parseISO(dateString), TIMEZONE);
  return format(date, "yyyy-MM-dd'T'HH:mm");
};

export const convertToHours = (timeString: string): number => {
  const [hours, minutes] = timeString.split("h ");
  return parseInt(hours) + parseInt(minutes) / 60;
};

export const formatDisplayHours = (hours: number, precision: 0 | 2 = 2) => {
  const formatted = `${hours.toFixed(precision)}h`;
  return formatted;
};

export const formatHoursDifference = (workedHours: number, expectedHours: number) => {
  const difference = workedHours - expectedHours;
  if (Math.abs(difference) < 1) return "";
  const sign = difference > 0 ? "+" : "-";
  const label = ` (${sign}${Math.round(Math.abs(difference))}h)`;
  return label;
};

// Signed cumulative balance shown on its own (no worked/expected pair, no tolerance band).
export const formatSaldo = (hours: number) => {
  const rounded = Math.round(hours);
  if (rounded === 0) return "0h";
  const sign = rounded > 0 ? "+" : "-";
  const label = `${sign}${Math.abs(rounded)}h`;
  return label;
};

export const getDaysArray = (start: Date, end: Date) => {
  const arr = Array<Date>();
  for (let dt = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
    arr.push(new Date(dt));
  }
  return arr;
};

// Hours are credited per day at the entry's ACTUAL times, so a multi-day span has no honest per-day
// value — those entries are excluded instead of valued at an invented time. The backend rejects new
// multi-day entries, so this only ever drops legacy rows.
export const createTimeOffEntries = (timeOffRaw: any[]): TimeOff[] => {
  const singleDayEntries = timeOffRaw.filter((entry) => {
    if (!entry?.start_date || !entry?.end_date) return false;
    const start = parseISO(entry.start_date);
    const end = parseISO(entry.end_date);
    return isSameDay(start, end);
  });
  return singleDayEntries;
};
